import { render, staticRenderFns } from "./settings-lists-suppliers.vue?vue&type=template&id=62418b64&"
import script from "./settings-lists-suppliers.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-suppliers.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports